import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import EmailIcon from '@mui/icons-material/MailOutlineRounded';
import { useAuth } from '../auth/AuthProvider';
import { useTranslation } from '../i18n';
import { PageHeader } from '../components/Section';
import { BRAND } from '../lib/brand';

const SUPPORT_EMAIL = BRAND.supportEmail;

export default function Support() {
  const t = useTranslation();
  const { user } = useAuth();

  const who = user?.name || user?.email || '';
  const subject = who
    ? `Support request from ${who}`
    : 'Support request';
  const mailto = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}`;

  return (
    <Box>
      <PageHeader title={t.support.title} description={t.support.description} />
      <Paper sx={{ p: 3, maxWidth: 560 }}>
        <Stack spacing={2}>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {t.support.body}
          </Typography>
          <Box>
            <Button
              variant="contained"
              startIcon={<EmailIcon />}
              href={mailto}
            >
              {t.support.emailButton} {SUPPORT_EMAIL}
            </Button>
          </Box>
        </Stack>
      </Paper>
    </Box>
  );
}
